import Enum from "../../../../../../enums/Enum";

const CranialNervesDropdownValues = new Enum({
    CN0: {name: "Normal"},
    CN1: {name: "Weak"},
    CN3: {name: "Absent"},
    CN4: {name: "Exagerrated"},
});

export default CranialNervesDropdownValues;